import styled from "styled-components";

export const PremiumPubTournamentTimerWrapper = styled.div<{
  width?: number;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 14px;
  background: ${(p) => (p.width ? "none" : "rgba(100, 54, 231, 1)")};
  display: flex;
  justify-content: center;
  align-items: center;

  > .time {
    color: white;
    font-size: ${(p) => (p.width ? 18 : 14)}px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const PremiumPubTournamentTimerCircle = styled.svg<{
  progress: number;
  width?: number;
}>`
  width: ${(p) => (p.width ? p.width : 57)}px;
  height: ${(p) => (p.width ? p.width : 57)}px;
  border-radius: 50%;
  transform: rotate(0.25turn);

  circle {
    fill: none;
    stroke-width: ${(p) => (p.width ? 10 : 8)};
  }

  .background {
    stroke: #fff;
  }

  .progress {
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }

  .donut-container {
    position: relative;
    top: 8px;
    left: 8px;
    width: 57px;
    height: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .donut-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: 4px solid transparent;
    border-color: white;
  }

  .donut-progress {
    position: absolute;
    right: 0px;
    transform: rotateZ(${(props) => 360 - (360 * props.progress) / 100}deg);
  }
`;
